module.exports = __webpack_public_path__ + "img/big_11B22_orange.f6861a62.png";